import { makeAutoObservable, when } from 'mobx'
import { Database } from 'mobx-document'
import authenticationStore from './authenticationStore'
import {
  BeWizrLibraryCalendarItemsEndpoint,
  BeWizrLibraryCategoriesEndpoint,
  BeWizrLibraryCategoryDocument,
  BeWizrLibraryItemDocument,
  BeWizrLibraryItemsEndpoint,
  BeWizrLibraryTopicDocument,
  BeWizrLibraryTopicsEndpoint,
} from './bewizr-library'
import searchStore from './searchStore'
import { register } from './support'
import bewizrStore from './bewizrStore'

export class BeWizrLibraryStore {

  constructor() {
    makeAutoObservable(this)
  }

  public async init() {
    authenticationStore.on('logout', this.onLogOut)
    await when(() => bewizrStore.authenticated, () => {
      searchStore.registerEndpoint('bewizr-topics', new BeWizrLibraryTopicsEndpoint(this.topics, {}))
      searchStore.registerEndpoint('bewizr-library-items', new BeWizrLibraryItemsEndpoint(this.items, {}), {
        showMoreHref: query => `//bewizr-library?query=${query}`,
      })
    })
  }

  public readonly topics = new Database<BeWizrLibraryTopicDocument>({
    getID:         topic => topic.slug,
    getDocument:   topic => new BeWizrLibraryTopicDocument(topic.slug, {initialData: topic}),
    emptyDocument: slug    => new BeWizrLibraryTopicDocument(slug),
  })

  public readonly categories = new Database<BeWizrLibraryCategoryDocument>({
    getID:         category => category.slug,
    getDocument:   category => new BeWizrLibraryCategoryDocument(category.slug, {initialData: category}),
    emptyDocument: slug     => new BeWizrLibraryCategoryDocument(slug),
  })

  public readonly items = new Database<BeWizrLibraryItemDocument>({
    getID:         item => item.id,
    getDocument:   item => new BeWizrLibraryItemDocument(item.id, {initialData: item}),
    emptyDocument: id => new BeWizrLibraryItemDocument(id),
  })

  public readonly allTopics        = new BeWizrLibraryTopicsEndpoint(this.topics, {})
  public readonly allCategories    = new BeWizrLibraryCategoriesEndpoint(this.categories, {})
  public readonly allItems         = new BeWizrLibraryItemsEndpoint(this.items, {})
  public readonly allCalendarItems = new BeWizrLibraryCalendarItemsEndpoint(this.items, {})

  private onLogOut = () => {
    this.topics.clear()
    this.categories.clear()
    this.items.clear()
  }

}

export default register(new BeWizrLibraryStore())